function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Controller, useForm } from 'react-hook-form';
import { Column, ConfirmationModal, FullColumn, IconButton, Row, TextField, Typography, useOverlayContext } from 'seagull';
import { ThumbDown24, ThumbDownFilled24, ThumbUp24, ThumbUpFilled24 } from 'seagull/icons';
import { useSubmitServiceDescriptionFeedback } from "../../../../hooks/reactQuery/mutations/useSubmitServiceDescriptionFeedback";
import { useStoreActions } from "../../../../store/store-context";
import { FeedbackModalTestIds } from "./FeedbackModal.utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const FeedbackModal = _ref => {
  let {
    conversationId,
    onClose
  } = _ref;
  const {
    logBI
  } = useStoreActions();
  const {
    submitFeedback,
    isLoading
  } = useSubmitServiceDescriptionFeedback();
  const {
    showSuccessToast
  } = useOverlayContext();
  const {
    control,
    handleSubmit,
    formState: {
      errors
    }
  } = useForm({
    mode: 'onSubmit',
    defaultValues: {
      rating: null,
      comment: ''
    }
  });
  const showError = !!errors.rating;
  const handleRatingChange = newRating => {
    if (newRating === 'thumbsUp') {
      logBI(17012);
    } else if (newRating === 'thumbsDown') {
      logBI(17013);
    }
  };
  const onSubmit = async data => {
    const feedbackText = data.comment.trim() || undefined;
    logBI(17014, {
      feedbackText
    });
    await submitFeedback({
      conversationId,
      data: {
        rating: data.rating,
        comment: feedbackText
      }
    });
    showSuccessToast('Thanks for your feedback!', FeedbackModalTestIds.SuccessToast());
    onClose();
  };
  return /*#__PURE__*/_jsx(ConfirmationModal, {
    width: "550px",
    title: "Your feedback helps us improve",
    showFooter: true,
    onPrimaryButtonClick: handleSubmit(onSubmit),
    primaryButtonLabel: "Submit",
    primaryButtonLoading: isLoading,
    primaryButtonTestid: FeedbackModalTestIds.SubmitButton(),
    secondaryButtonLabel: "Close",
    onSecondaryButtonClick: onClose,
    secondaryButtonTestid: FeedbackModalTestIds.CloseButton(),
    content: /*#__PURE__*/_jsxs(FullColumn, {
      gap: 16,
      children: [/*#__PURE__*/_jsxs(Row, {
        alignItems: "center",
        gap: 8,
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "paragraph1",
          "data-testid": FeedbackModalTestIds.RatingQuestion(),
          children: "How would you rate the suggestions?"
        }), /*#__PURE__*/_jsx(Controller, {
          control: control,
          name: "rating",
          rules: {
            required: 'Please select a rating'
          },
          render: _ref2 => {
            let {
              field: {
                onChange,
                value
              }
            } = _ref2;
            return /*#__PURE__*/_jsxs(Row, {
              gap: 4,
              children: [/*#__PURE__*/_jsx(IconButton, {
                onClick: () => {
                  const newValue = value === 'thumbsUp' ? null : 'thumbsUp';
                  handleRatingChange(newValue);
                  onChange(newValue);
                },
                "data-testid": FeedbackModalTestIds.ThumbsUpButton(),
                "data-selected": value === 'thumbsUp',
                "data-error": showError && !value ? 'true' : undefined,
                skin: showError && !value ? 'error' : 'standard',
                children: value === 'thumbsUp' ? /*#__PURE__*/_jsx(ThumbUpFilled24, {}) : /*#__PURE__*/_jsx(ThumbUp24, {})
              }), /*#__PURE__*/_jsx(IconButton, {
                onClick: () => {
                  const newValue = value === 'thumbsDown' ? null : 'thumbsDown';
                  handleRatingChange(newValue);
                  onChange(newValue);
                },
                "data-testid": FeedbackModalTestIds.ThumbsDownButton(),
                "data-selected": value === 'thumbsDown',
                "data-error": showError && !value ? 'true' : undefined,
                skin: showError && !value ? 'error' : 'standard',
                children: value === 'thumbsDown' ? /*#__PURE__*/_jsx(ThumbDownFilled24, {}) : /*#__PURE__*/_jsx(ThumbDown24, {})
              })]
            });
          }
        })]
      }), /*#__PURE__*/_jsxs(Column, {
        gap: 8,
        alignItems: "start",
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "paragraph1",
          "data-testid": FeedbackModalTestIds.CommentLabel(),
          children: "Please share your thoughts:"
        }), /*#__PURE__*/_jsx(Controller, {
          control: control,
          name: "comment",
          render: _ref3 => {
            let {
              field
            } = _ref3;
            return /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({
              collapseHelperText: false
            }, field), {}, {
              multiline: true,
              minRows: 3,
              maxRows: 3,
              placeholder: "Write here...",
              "data-testid": FeedbackModalTestIds.CommentInput()
            }));
          }
        })]
      })]
    }),
    onCloseButtonClick: onClose,
    "data-testid": FeedbackModalTestIds.Root()
  });
};
export default FeedbackModal;